import { useMemo } from 'react';

import { getCurrentEnvironment } from '@/constants/config';
import { storage, storageKeys } from '@/constants/storage';
import { useLaunchDarklyFlag } from '@/hooks/flags/useLaunchDarklyFlag';
import type { DepositBreakdown } from '@/types/booking';
import { buildMockDeposit, parseDepositMockMode } from '@/utils/depositMock';

import type { UseDepositDueTodayParams } from './types';

export const useDepositDueToday = ({
  shop,
  cart,
}: UseDepositDueTodayParams): DepositBreakdown | null => {
  const flagEnabled = useLaunchDarklyFlag('booking-deposits-enabled', false);
  const mockMode = parseDepositMockMode(
    storage.getString(storageKeys.depositMock),
  );

  return useMemo(() => {
    if (!cart) {
      return null;
    }

    const currency = cart.currency || shop?.brand?.currency;
    const gatePassed =
      flagEnabled &&
      !!shop?.settings?.paymentDepositsEnabled &&
      !!shop.requiresPartialDeposits &&
      currency?.toUpperCase() === 'USD';

    const deposit = cart.breakdown?.deposit;
    if (gatePassed && deposit && deposit.total > 0) {
      return deposit;
    }

    if (mockMode && getCurrentEnvironment() !== 'production') {
      return buildMockDeposit(cart.breakdown?.breakdownPrice, mockMode);
    }

    return null;
  }, [flagEnabled, shop, cart, mockMode]);
};
